import * as React from 'react';
import Stack from '@mui/material/Stack';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import PaymentsIcon from '@mui/icons-material/Payments';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ContactsIcon from '@mui/icons-material/Contacts';
import Box from '@mui/system/Box';

const getAccountSections = () => {
	return [{
		title: 'Your orders',
		subTitle: 'Track, return or buy things again',
		url: '/order-summary'
	}, {
		title: 'Login and security',
        subTitle: 'Edit login, name, mobile',
		url: '/update-profile'
	}, {
		title: 'Your addresses',
		subTitle: 'Add or Edit addresses for orders',
		url: '/addresses'
	}, {
		title: 'Payment options',
		subTitle: 'Edit or add payment methods',
		url: '/payment-methods'
	}]
}

const getIcon = (title: string) => {
	let icon: any = null
	switch(title) {
		case 'Your orders':
			icon = <LocalShippingIcon style={{ fontSize: '30px'}} />
			break;
		case 'Login and security':
			icon = <LockOpenIcon />
			break;
        case 'Your addresses':
            icon = <ContactsIcon  style={{ fontSize: '30px'}} />
            break;
		case 'Payment options':
			icon = <PaymentsIcon  style={{ fontSize: '30px'}} />;
			break;
		default:
			icon = '';					
	}
	return icon;
}

interface AccountSectionType {
	title: string;
	subTitle: number;
	url: string
}
interface UserProfileProps {
	data: any;
	setSelectedListItemHandler: (path: string) => void;
}

const UserProfile = (props: UserProfileProps) => {
	const { data = {}, setSelectedListItemHandler } = props;
	const accountSections = data && getAccountSections()
	return (
        <Box p={4} style={{minHeight: '59vh'}}>
            <Grid container spacing={2} textAlign='center'>
                {accountSections.map((item: AccountSectionType, index: number) => {
                    return <Grid item xs={12} sm={3} key={index}>
                        <Card onClick={() => setSelectedListItemHandler(item.url)}>
                            <Stack direction="row" 
                                spacing={2} justifyContent='center'
                                border="2px solid #1976d2"
                                padding="8px"
                            >
                                {getIcon(item.title)}
                                <Typography gutterBottom variant="h5" component="div">
                                    {item.title}
                                </Typography>
                            </Stack>
                            <CardContent style={{
                                    backgroundColor: '#1976d2',
                                    color: '#fff',
                                    marginTop: '0px',
                                    minHeight: '15vh'
                                }}
                            >
                                <Typography gutterBottom variant="h6" component="div">
                                    {item.subTitle}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                })}
            </Grid>
        </Box>
	);
}

export default UserProfile;
